import {} from "@ant-design/icons";
import { Menu, Modal } from "antd";
// import { useEffect } from "react";
// import { useState } from "react";
// import { useCookies } from "react-cookie";
import { useNavigate } from "react-router-dom";

import "../../../assets/style/menu.scss";
import SelectLanguage from "../../common/Selector/SelectLanguage";
import User from "../../common/User";
import { useDispatch } from "react-redux";
import { logOut } from "../../../services/slice/AuthSlice";
import { useEffect, useMemo, useState } from "react";
import { getMenuForAdmin } from "../../../services/slice/ConfigMenuSlice";
import { useSelector } from "react-redux";
import {
  accountSelector,
  configMenuSelector,
} from "../../../services/selector/index.";
import { useRef } from "react";
import { IconArrowLeft, IconArrowRight } from "../../../assets/icon";
import Notify from "../../common/Notify";
import {
  resetStateAcc,
  setIsConfirm,
} from "../../../services/slice/AccountSlice";
const AppMenu = () => {
  const [showMenu, setShowMenu] = useState(false);
  const stateAcc = useSelector(accountSelector);
  const navigate = useNavigate();
  const dispatch = useDispatch();
  const menuState = useSelector(configMenuSelector);
  const { dataMenuForAdmin } = menuState;
  const [language, setlanguage] = useState("Tiếng Việt");
  const languageCheck = localStorage.getItem("language");
  const menuRef = useRef();
  function useOutsideAlerter(ref) {
    useEffect(() => {
      function handleClickOutside(event) {
        if (ref.current && !ref.current.contains(event.target)) {
          setShowMenu(false);
        }
      }
      // Bind the event listener
      document.addEventListener("mousedown", handleClickOutside);
      return () => {
        // Unbind the event listener on clean up
        document.removeEventListener("mousedown", handleClickOutside);
      };
    }, [ref]);
  }
  useOutsideAlerter(menuRef);
  useEffect(() => {
    dispatch(getMenuForAdmin());
  }, [dispatch]);
  useEffect(() => {
    setlanguage(languageCheck);
  }, [languageCheck]);
  function getItem(label, key, icon, children, type) {
    return {
      key,
      icon,
      children,
      label,
      type,
    };
  }
  const items = useMemo(() => {
    const result = [];
    dataMenuForAdmin?.map((value) => {
      if (value.type === 1) {
        const arr = [];
        value.child.map((item) =>
          arr.push(
            getItem(
              language === "Tiếng Việt" ? item.nameVn : item.nameEn,
              item.router,
              <img
                src={`${window.SERVER_URL}/${item.icon}`}
                alt=""
                className="css-icon"
              />
            )
          )
        );
        result.push(
          getItem(
            language === "Tiếng Việt" ? value.nameVn : value.nameEn,
            value.router,
            <img
              src={`${window.SERVER_URL}/${value.icon}`}
              alt=""
              className="css-icon"
            />,
            arr
          )
        );
      } else {
        // eslint-disable-next-line jsx-a11y/alt-text
        result.push(
          getItem(
            language === "Tiếng Việt" ? value.nameVn : value.nameEn,
            value.router,
            <img
              src={`${window.SERVER_URL}/${value.icon}`}
              alt=""
              className="css-icon"
            />
          )
        );
      }
    });
    return result;
  }, [dataMenuForAdmin, language]);

  const defaultMenu = localStorage.getItem("keyMenu");

  const handleChangePage = (value) => {
    if (value.key === "logout") {
      dispatch(logOut());
      localStorage.removeItem("accessToken");
      localStorage.removeItem("keyMenu");
      navigate("/login");
      setShowMenu(false);
      return;
    }
    localStorage.setItem("keyMenu", value.key);
    navigate(`/${value.key}`);
    setShowMenu(false);
  };
  const success = () => {
    Modal.success({
      content: "Đổi mật khẩu thành công. Vui lòng đăng nhập lại.",
      onOk() {
        dispatch(setIsConfirm(false));
        localStorage.clear();
        navigate("/login");
        dispatch(logOut());
      },
    });
  };
  useEffect(() => {
    if (stateAcc.isConfirm) {
      success();
    }
  }, [stateAcc.isConfirm]);
  return (
    <>
      <Notify
        content={stateAcc.msg}
        isNotify={stateAcc.isNotify}
        title="Thông báo"
        reset={resetStateAcc}
        type={stateAcc.typeNotify}
      />
      <div className="wrapperMenu ">
        <div className="infoUser d-flex flex-column align-items-center justify-content-between ">
          <div
            className="d-flex align-items-center justify-content-between "
            style={{ width: "100%" }}
          >
            <User />
          </div>
          <hr></hr>
        </div>
        <Menu
          className="menu"
          mode="inline"
          onClick={handleChangePage}
          defaultSelectedKeys={[defaultMenu ? defaultMenu : "deals"]}
          defaultOpenKeys={["root"]}
          items={items}
        ></Menu>
        <div className="footerMenu">
          <SelectLanguage />
        </div>
      </div>
      <div className="miniMenu">
        <User mini />
        <span className="iconShowMenu" onClick={() => setShowMenu(true)}>
          <IconArrowRight />
        </span>
        <SelectLanguage mini width={60} style={{ fontSize: "14px" }} />
      </div>
      <div
        ref={menuRef}
        className={`wrapperMenuScreenMedium ${
          showMenu ? "show" : "hiden"
        } d-flex flex-column`}
      >
        <div className="infoUser d-flex flex-column align-items-center justify-content-between ">
          <div
            className="d-flex align-items-center justify-content-between "
            style={{ width: "100%" }}
          >
            <User handleSetShow={() => setShowMenu(false)} />
          </div>
          <hr></hr>
        </div>
        <Menu
          className="menu"
          mode="inline"
          onClick={handleChangePage}
          defaultSelectedKeys={[defaultMenu ? defaultMenu : "deals"]}
          defaultOpenKeys={["root"]}
          items={items}
        />
        <span className="iconArrowLeft" onClick={() => setShowMenu(false)}>
          {" "}
          <IconArrowLeft />
        </span>
        <div className="footerMenu">
          <SelectLanguage />
        </div>
      </div>
    </>
  );
};
export default AppMenu;
